import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

// WYSIWYG editor for Quotation's "Footer Notes" field (Payment Terms/
// Validity/Warranty/Please Note style content, printed verbatim after the
// line items - see StockDocumentPreview.jsx's footerNotesHtml slot). A
// deliberately small toolbar - this is a print footer, not a document
// editor - bold/italic/underline plus lists covers the real-world content
// shape (labelled terms, bulleted notes) without inviting font/color
// chaos into a printed customer-facing document.
const TOOLBAR = [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], ["clean"]];

const RichTextEditor = ({ value, onChange, readOnly = false, placeholder }) => (
  <ReactQuill
    theme="snow"
    value={value || ""}
    onChange={onChange}
    readOnly={readOnly}
    placeholder={placeholder}
    modules={{ toolbar: readOnly ? false : TOOLBAR }}
  />
);

export default RichTextEditor;
